export const locale = {
  lang: 'es',
  data: {
    'TEMPLATE':{
      'PANT_TEMPLATE':{
        'NO_MODIF':'No modifique el contenido de esta celda',
        'INST_1':'Descargar la plantilla de preguntas',
        'INST_2':'Realizar los cambios necesarios en la plantilla',
        'INST_3':'Cargar la plantilla de preguntas',
        'BTN_DESC_PLAN':'Plantilla de preguntas',
        'BUSC_PLAN_TEX':'Presioné aqui para buscar la plantilla de preguntas',
        'TEMP_CARG_TIT':'Información de la plantilla',
        'TOT_PREG':'Total preguntas',
        'TOT_PREG_MODI':'Total preguntas modificadas',
        'TOT_PREG_NUE':'Total preguntas nuevas',
        'TEMP_CARG_TIT_CAR':'Información de la plantilla cargada',
        'COMPL_PAS_SIN_MODI':'Aún no ha realizado ninguna modificación.\n\n ¿Esta seguro de completar el paso?',
        'SUCC_CAR_PLAN':'Se cargó correctamente la plantilla.\n\n Por favor completa el paso.',
        'COMPLE_PASO_CON_MODI':'¿Está seguro de completar el paso con los cambios introducidos actualmente?',
        'ERROR_CARGA': 'No se puede cargar el archivo, se detectaron modificaciones en una o más celdas restringidas, vuelva a descargar la plantilla y realice las modificaciones deseadas sin modificar las celdas restringidas.\n\nLas celdas restringidas contienen un comentario que indica que no debe modificarse su contenido',
        'FORALL_EXCEDIDAS': 'Se detectó que el número de prácticas 4All presentes en la plantilla cargada excede el número de prácticas permitidas, sólo se cargaron las prácticas que corresponden al máximo permitido',
        'OPCIONDEMOGRAFICOS': 'Esta celda debe contener un valor sin modificar de la hoja del catálogo de demográficos',
        'CARGANDO_PREGUNTAS': 'Cargando preguntas de la plantilla'
      },
      'CATALOGO_IDIOMAS':{
        'z1':'Chino Simplificado',
        'z2':'Chino Tradicional',
        'ko':'Koreano',
        'ja':'Japones',
        'pt':'Portugués',
        'en':'Ingles',
        'fr':'Frances',
        'de':'Aleman',
        'it':'Italiano',
        'es':'Español',
        'tr':'Turco',
        'ms':'Malayo',
        'ro':'Rumano',
        'vi':'Vietnamita',
        'bg':'Búlgaro',
        'hi':'Hindi',
        'ru':'Ruso',
        'mn':'Mongolian',
        'nl': 'Holandés',
        'ar': 'Árabe',
        'ua': 'Ucraniano',
        'id': 'Indonesio',
      },
      'HOJAS_EXCEL':{
       'Instrucciones':'Instrucciones',
       'Catalogo':'Catalogo',
       'Detalles': 'Detalles',
       'CatDemograficos': 'Catálogo de demográficos',
       'Nps':'Nps',
       'Reactivos':'Reactivos',
       'Control':'Control',
       'Demograficos':'Demograficos',
       'Abiertas':'Abiertas',
       'Forall':'Forall',
       'Adicionales':'Adicionales',
     },
     'COLUMNAS_H_CATA':{
       'ClaveIdiomas':'Clave idiomas',
       'NombreIdiomas':'Nombre idiomas',
       'IDTipoPregunta': 'ID tipo de pregunta',
       'TiposPreguntas': 'Tipos de preguntas',
       'ClaveTipoElemento': 'Clave tipo de elemento',
       'TiposElementos': 'Tipos de elementos',
       'CONTEM_TIP_PREG':{
         '1':	'Pregunta NPS / Control / Adicional (multiple opción, una respuesta)',
         '2_1':'Pregunta NPS / Control / abierta, tipo texto abierto',
         '2_2':'Pregunta NPS / Control / abierta, tipo texto numérico',
         '3':'Pregunta de tipo reactivo',
         '4':'Pregunta tipo demográfico (múltiple opción, una respuesta)',
         '5':'Práctica 4All',
         '6':'Pregunta adicional (múltiple opción, múltiples respuestas)',
       },
       'CONTEM_TIP_SEGM':{
         'question':	'Texto de la pregunta',
         'answer_1':	'Texto de la respuesta 1',
         'answer_2':	'Texto de la respuesta 2',
         'answer_n':	'Texto de la respuesta n',
         'practice':	'Texto de la práctica 4All',
         'description':	'Texto de la descripción de la práctica 4All',
         'statement_1':	'Pregunta 1 de la práctica 4All',
         'statement_2':	'Pregunta 2 de la práctica 4All',
       }
     },
     'COLUMNAS_SECCION':{
      'Id':	'Id',
      'TipoDePregunta':	'TipoDePregunta',
      'PalabrasClave':	'PalabrasClave',
      'NuevaPregunta':	'NuevaPregunta',
      'Eliminable':	'Eliminable',
      'Editable':	'Editable',
      'RespuestaObligatoria':	'RespuestaObligatoria',
      'MostrarPregunta':	'MostrarPregunta',
      'Dimension':	'Dimension',
      'Competencia':	'Competencia',
      'Subcompetencia':	'Subcompetencia',
      'TipoDemografico':	'TipoDemografico',
      'practice':	'practica',
      'description':	'descripcion',
      'statement_1':	'practica_1',
      'statement_2':	'practica_2',
      'question':	'pregunta',
      'answer':	'opcion',
      'OpcionOtro': 'Respuesta tipo "Otro"'
     }
    }
  }
};
